module.exports = __webpack_public_path__ + "static/IBMPlexSans-Italic-32dd0899cca44324e7c573d6f0ba3ab2.woff";